import { render, staticRenderFns } from "./MaterialShipToCenter.vue?vue&type=template&id=aad87356&"
import script from "./MaterialShipToCenter.vue?vue&type=script&lang=ts&"
export * from "./MaterialShipToCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports